/**
 * Der Zugangscode des geschlossenen Playtests, im Browser gemerkt
 * (Produktentscheidung vom 04.10.2026).
 *
 * Gemerkt wird er in localStorage, nicht in sessionStorage: Wer einmal
 * hereingelassen wurde, soll ihn nicht bei jedem Besuch neu abtippen.
 *
 * Das ist reine Bequemlichkeit. Geprueft wird ausschliesslich auf dem Server
 * (Masterprompt Abschnitt 28/29) - hier liegt nur eine Kopie dessen, was der
 * Spieler ohnehin selbst kennt. Wer sie aus dem Browser liest, hat damit
 * nichts gewonnen, was er nicht schon haette.
 */

const SPEICHER_SCHLUESSEL = 'dueline.zugangscode';

/**
 * Bringt einen Code in die Form, in der er verschickt wird.
 *
 * Der Server ist bei Strichen und Schreibweise ohnehin nachsichtig; hier wird
 * nur Beiwerk am Rand entfernt, damit ein versehentliches Leerzeichen beim
 * Einfuegen nicht wie ein falscher Code aussieht.
 */
export function putzeZugangscode(roh: string): string {
  return roh.trim();
}

/** Liest den gemerkten Code. Leer, wenn keiner da ist. */
export function ladeZugangscode(): string {
  try {
    return localStorage.getItem(SPEICHER_SCHLUESSEL) ?? '';
  } catch {
    // Privates Fenster oder gesperrter Speicher - dann eben jedes Mal neu.
    return '';
  }
}

/** Merkt sich den Code. Ein leerer Code loescht den gemerkten. */
export function speichereZugangscode(code: string): void {
  try {
    const sauber = putzeZugangscode(code);
    if (sauber === '') localStorage.removeItem(SPEICHER_SCHLUESSEL);
    else localStorage.setItem(SPEICHER_SCHLUESSEL, sauber);
  } catch {
    // Kein Speicher verfuegbar - der Code gilt dann nur fuer diesen Besuch.
  }
}

/** Die drei Gruende, aus denen der Server die Tuer zulaesst. */
export const ZUGANG_FEHLER = {
  /** Es wurde kein Code geschickt - der Client soll danach fragen. */
  fehlt: 'access_code_required',
  /** Der Code steht nicht auf der Liste. */
  falsch: 'access_code_invalid',
  /** Der Server hat gar keine Liste - niemand kommt herein. */
  geschlossen: 'access_closed',
} as const;

/** Ist diese Fehlermeldung eine Absage an der Tuer? */
export function istZugangsfehler(meldung: string | null): boolean {
  if (!meldung) return false;
  const text = meldung.toLowerCase();
  return Object.values(ZUGANG_FEHLER).some((grund) => text.includes(grund));
}
